import { getLocalValue } from "../utils/auth";

export const Role = {
  COACH: 1,
  COACHEE: 2,
  SUPER_ADMIN: 3,
  IT_MANAGER: 4,
  CAMPAIGN_MANAGER: 5,
  SUPPORT_ADMIN: 6,
  COE_ADMIN: 7,
  EXECUTIVE: 8,
  HR: 9,
  COORDINATOR: 10,
  CEO: 11,
  NORMAL_COACH: 0,
};
export const AdminRole = {
  IT_MANAGER: 1,
  SUPER_ADMIN: 2,
  CAMPAIGN_MANAGER: 3,
  SUPPORT_ADMIN: 4,
  COE_ADMIN: 5,
  EXECUTIVE: 6,
  HR: 7,
  COORDINATOR: 8,
  CEO: 9,
};

export const IsCoach = () => {
  const userRole = parseInt(getLocalValue("u_role"));
  return userRole === Role.COACH;
};
export const IsCoachee = () => {
  const userRole = parseInt(getLocalValue("u_role"));
  return userRole === Role.COACHEE;
};

export const IsSessionCoach = coachId => {
  const userId = parseInt(getLocalValue("uid"));
  return coachId === userId;
};
export const IsSessionCoachee = coacheeId => {
  const userId = parseInt(getLocalValue("uid"));
  return coacheeId === userId;
};

export const IsSessionReadOnly = (coachId, coacheeId) => {
  const uid = parseInt(getLocalValue("uid"));
  if (coachId === uid) return false;
  if (coacheeId === uid) return false;
  if (IsCoordinator()) return true;
  return false;
};

//IT Manager
export const IsAdmin = () => {
  const coachingRole = parseInt(getLocalValue("u_coaching_role"));
  return Role.IT_MANAGER === coachingRole;
};
export const IsSuperAdmin = () => {
  const coachingRole = parseInt(getLocalValue("u_coaching_role"));
  return Role.SUPER_ADMIN === coachingRole;
};

export const IsCampaignAdmin = () => {
  const coachingRole = parseInt(getLocalValue("u_coaching_role"));
  return (
    Role.CAMPAIGN_MANAGER === coachingRole || Role.COORDINATOR === coachingRole
  );
};

export const IsCampaignManager = () => {
  const coachingRole = parseInt(getLocalValue("u_coaching_role"));
  return Role.CAMPAIGN_MANAGER === coachingRole;
};

export const IsCoordinator = () => {
  const coachingRole = parseInt(getLocalValue("u_coaching_role"));
  return Role.COORDINATOR === coachingRole;
};
export const IsCOEAdmin = () => {
  const coachingRole = parseInt(getLocalValue("u_coaching_role"));
  return Role.COE_ADMIN === coachingRole;
};

export const IsExecutive = () => {
  const coachingRole = parseInt(getLocalValue("u_coaching_role"));
  return Role.EXECUTIVE === coachingRole;
};

export const IsCEO = () => {
  const coachingRole = parseInt(getLocalValue("u_coaching_role"));
  return Role.CEO === coachingRole;
};

export const IsSupportAdmin = () => {
  const coachingRole = parseInt(getLocalValue("u_coaching_role"));
  return Role.SUPPORT_ADMIN === coachingRole;
};

export const IsHR = () => {
  const coachingRole = parseInt(getLocalValue("u_coaching_role"));
  return Role.HR === coachingRole;
};

export const IsNormalCoach = () => {
  const coachingRole = parseInt(getLocalValue("u_coaching_role"));
  return Role.NORMAL_COACH === coachingRole;
};

/**
 * Header display role:
 * - Normal user → Coach / Coachee (from u_role)
 * - Non-normal admin roles → Admin Role label (FUM / Coordinator / COE / Executive / Support Admin / etc.)
 */
export const getHeaderDisplayRole = () => {
  const coachingRole = parseInt(getLocalValue("u_coaching_role"));
  const userRole = parseInt(getLocalValue("u_role"));
  if (coachingRole === Role.NORMAL_COACH) {
    if (userRole === Role.COACH) return "Coach";
    if (userRole === Role.COACHEE) return "Coachee";
    return null;
  }
 
  switch (coachingRole) {
    case Role.CAMPAIGN_MANAGER:
      return "Functional Unit Manager";
    case Role.COORDINATOR:
      return "Coordinator";
    case Role.COE_ADMIN:
      return "COE";
    case Role.EXECUTIVE:
      return "Executive";
    case Role.SUPPORT_ADMIN:
      return "Support Admin";
    case Role.SUPER_ADMIN:
      return "Super Admin";
    case Role.IT_MANAGER:
      return "IT Manager";
    case Role.HR:
      return "HR";
    case Role.CEO:
      return "CEO";
    default:
      return null;
  }
};

export const IsPageAccessible = (coachId, coacheeId) => {
  if (
    IsSessionCoach(coachId) ||
    IsSessionCoachee(coacheeId) ||
    IsSupportAdmin() ||
    IsCampaignAdmin()
  ) {
    return true;
  }

  return false;
};
